/* eslint-disable max-statements */
/* eslint-disable complexity */
/* eslint-disable react/prop-types */
/* eslint-disable no-console */
import {Card, CardContent, Box, Grid, FormControl, InputLabel, TextField, Typography, FileInputField, Alert} from '@deere/fuel-react';
import Snackbar from '@mui/material/Snackbar';
import {getUserInfoFromContactUsAPI} from '../../services/snow.service';
import {useEffect, useState} from 'react';
import {constants} from '../../util/constants';
import {useOktaAuth} from '@okta/okta-react';

export default function FormGeneric({
    errors, register, setValue, usrId, setFiles, comments
}) {
    const {authState} = useOktaAuth();
    const [userInfo, setUserInfo] = useState({});
    const [textUserId, setTextUserId] = useState('');
    const [snackConfig, setSnackConfig] = useState({
        open: false,
        vertical: 'bottom',
        horizontal: 'right'
    });

    const {
        open, vertical, horizontal
    } = snackConfig;

    const callUserInfo = async (userIdValue) => {
        if (typeof userIdValue === 'string' && userIdValue.trim().length > 0) {
            const response = await getUserInfoFromContactUsAPI(authState.accessToken.accessToken, userIdValue.trim().toUpperCase());

            if (response && response.hasOwnProperty('identifier') && response.hasOwnProperty('organizationInfo') && response.hasOwnProperty('profileInfo')) {
                setUserInfo(response);
                setTextUserId(response.identifier.userId);
            } else {
                setUserInfo(undefined);
                setValue('userId', userIdValue);
                setValue('userName', '');
                setValue('jobTitle', '');
                setValue('email', '');
                setValue('comments', '');
                setTextUserId(userIdValue);
            }
        }
    };

    const handleBlur = (event) => {
        event.preventDefault();
        if (event.target.value.trim().toUpperCase() !== textUserId.trim().toUpperCase()) {
            callUserInfo(event.target.value);
        }
    };

    useEffect(() => {
        if (userInfo && 'identifier' in userInfo && 'userId' in userInfo.identifier) {
            const userId = userInfo.identifier.userId;

            setValue('userId', userId);
            setTextUserId(userId);
        }

        if (userInfo && 'profileInfo' in userInfo) {
            const name = `${userInfo.profileInfo.lastName ?? ''} ${userInfo.profileInfo.firstName ?? ''}`;
            const jobTitle = userInfo.profileInfo.jobTitle;

            setValue('userName', name);
            setValue('jobTitle', jobTitle);
        }

        if (userInfo && 'profileInfo' in userInfo && 'communicationInfo' in userInfo.profileInfo) {
            const email = userInfo.profileInfo.communicationInfo.email;

            setValue('email', email);
        }

        if (typeof usrId === 'string' && usrId.trim().length > 0 && JSON.stringify(userInfo) === '{}') {
            callUserInfo(usrId);
        }

        if (typeof comments === 'string' && comments.trim().length > 0) {
            setValue('comments', comments);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [setValue, userInfo, usrId, comments]);

    const handleAcceptedFiles = (event) => {
        if (Array.isArray(event) && event.length > 0) {
            setFiles([...event]);
        }
    };

    const handleClearFiles = () => {
        setFiles([]);
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackConfig({
            ...snackConfig,
            open: false
        });
    };

    const alert = (<Snackbar
        anchorOrigin={{
            vertical,
            horizontal
        }}
        key={vertical + horizontal}
        onClose={handleClose}
        open={open}
    >
        <Alert
            onClose={handleClose}
            sx={{
                width: '100%'
            }}
            title='File attachment error'
            variant='error'
        >
            {'The document attached should not be greater than 5 megabytes.'}
        </Alert>
    </Snackbar>);

    const handleRejectedFiles = (event) => {
        if (Array.isArray(event) && event.length > 0 && Array.isArray(event[0].errors) && event[0].errors.length > 0) {
            if (event[0].errors[0].code === constants.DROP_ZONE_ERROR_CODES.size) {
                setSnackConfig({
                    ...snackConfig,
                    open: true
                });
            }
        }
    };

    const textFieldName = userInfo && 'profileInfo' in userInfo ? (<TextField
        {...register('userName')}
        disabled
        error={errors.userName?.message}
        fullWidth
        helperText={errors.userName?.message}
        id='name'
        placeholder='Name'
        value={`${userInfo.profileInfo.lastName} ${userInfo.profileInfo.firstName}`}
    />) : (<TextField
        {...register('userName')}
        defaultValue={''}
        error={errors.userName?.message}
        fullWidth
        helperText={errors.userName?.message}
        id='name'
        placeholder='Name'
    />);

    const textFieldJobTitle = userInfo && 'profileInfo' in userInfo ? (<TextField
        {...register('jobTitle')}
        disabled
        error={errors.jobTitle?.message}
        fullWidth
        helperText={errors.jobTitle?.message}
        id='jobTitle'
        placeholder='Job Title'
        value={userInfo.profileInfo.jobTitle}
    />) : (<TextField
        {...register('jobTitle')}
        error={errors.jobTitle?.message}
        fullWidth
        helperText={errors.jobTitle?.message}
        id='jobTitle'
        placeholder='Job Title'
    />);

    const emailTextField = userInfo && 'profileInfo' in userInfo && 'communicationInfo' in userInfo.profileInfo ? (<TextField
        {...register('email')}
        disabled
        error={errors.email?.message}
        fullWidth
        helperText={errors.email?.message}
        id='email'
        placeholder='Email'
        value={userInfo.profileInfo.communicationInfo.email}
    />) : (<TextField
        {...register('email')}
        error={errors.email?.message}
        fullWidth
        helperText={errors.email?.message}
        id='email'
        placeholder='Email'
    />);

    const userIdTextField = (<TextField
        {...register('userId')}
        error={errors.userId?.message}
        fullWidth
        helperText={errors.userId?.message}
        id='userId'
        onBlur={handleBlur}
        placeholder='Caller ID'
    />);

    const phoneTextField = (<TextField
        {...register('phone')}
        fullWidth
        id='phone'
        placeholder='Phone'
    />);

    return (
        <>
            <Card>
                <CardContent>
                    <Box mt={2}>
                        <Grid
                            alignItems='flex-start'
                            container
                            spacing={4}
                        >
                            <Grid
                                item
                                md={4}
                                xs={12}
                            >
                                <FormControl
                                    fullWidth
                                    required={true}
                                >
                                    <InputLabel htmlFor='userId'>{'Caller ID'}</InputLabel>
                                    {userIdTextField}
                                </FormControl>
                            </Grid>
                            <Grid
                                item
                                md={4}
                                xs={12}
                            >
                                <FormControl
                                    fullWidth
                                    required={true}
                                >
                                    <InputLabel htmlFor='name'>{'Name'}</InputLabel>
                                    {textFieldName}
                                </FormControl>
                            </Grid>
                            <Grid
                                item
                                md={4}
                                xs={12}
                            >
                                <FormControl
                                    fullWidth
                                >
                                    <InputLabel htmlFor='jobTitle'>{'Job Title'}
                                        <Box
                                            display='inline'
                                            ml={1}
                                        >
                                            <Typography
                                                color='tertiary'
                                                component='span'
                                                size='xs'
                                            >
                                                {'(Optional)'}
                                            </Typography>
                                        </Box>
                                    </InputLabel>
                                    {textFieldJobTitle}
                                </FormControl>
                            </Grid>
                            <Grid
                                item
                                md={8}
                                xs={12}
                            >
                                <FormControl
                                    fullWidth
                                    required={true}
                                >
                                    <InputLabel htmlFor='email'>{'Email'}</InputLabel>
                                    {emailTextField}
                                </FormControl>
                            </Grid>
                            <Grid
                                item
                                md={4}
                                xs={12}
                            >
                                <FormControl fullWidth>
                                    <InputLabel htmlFor='phone'>
                                        {'Phone'}
                                        <Box
                                            display='inline'
                                            ml={1}
                                        >
                                            <Typography
                                                color='tertiary'
                                                component='span'
                                                size='xs'
                                            >
                                                {'(Optional)'}
                                            </Typography>
                                        </Box>
                                    </InputLabel>
                                    {phoneTextField}
                                </FormControl>
                            </Grid>
                            <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <FormControl fullWidth>
                                    <InputLabel htmlFor='supplierNumber'>
                                        {'Supplier Number'}
                                        <Box
                                            display='inline'
                                            ml={1}
                                        >
                                            <Typography
                                                color='tertiary'
                                                component='span'
                                                size='xs'
                                            >
                                                {'(Optional)'}
                                            </Typography>
                                        </Box>
                                    </InputLabel>
                                    <TextField
                                        {...register('supplierNumber')}
                                        fullWidth
                                        id='supplierNumber'
                                    />
                                </FormControl>
                            </Grid>
                            <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <FormControl fullWidth>
                                    <InputLabel htmlFor='supplierName'>
                                        {'Supplier Name'}
                                        <Box
                                            display='inline'
                                            ml={1}
                                        >
                                            <Typography
                                                color='tertiary'
                                                component='span'
                                                size='xs'
                                            >
                                                {'(Optional)'}
                                            </Typography>
                                        </Box>
                                    </InputLabel>
                                    <TextField
                                        {...register('supplierName')}
                                        fullWidth
                                        id=''
                                    />
                                </FormControl>
                            </Grid>
                            <Grid
                                item
                                md={12}
                                xs={12}
                            >
                                <FormControl fullWidth>
                                    <InputLabel htmlFor='appUrl'>
                                        {'URL of JDSN Application'}
                                        <Box
                                            display='inline'
                                            ml={1}
                                        >
                                            <Typography
                                                color='tertiary'
                                                component='span'
                                                size='xs'
                                            >
                                                {'(copy and paste the URL of the application page you received the error message)'}
                                            </Typography>
                                        </Box>
                                    </InputLabel>
                                    <TextField
                                        {...register('appUrl')}
                                        fullWidth
                                        id='appUrl'
                                        placeholder='https://...'
                                    />
                                </FormControl>
                            </Grid>
                            <Grid
                                item
                                md={12}
                                xs={12}
                            >
                                <FormControl
                                    fullWidth
                                    required={true}
                                >
                                    <InputLabel>
                                        {'Comments / Questions'}
                                    </InputLabel>
                                    <TextField
                                        {...register('comments')}
                                        defaultValue={comments}
                                        error={errors.comments?.message}
                                        helperText={errors.comments?.message}
                                        minRows={5}
                                        multiline={true}
                                        required={true}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid
                                item
                                md={12}
                                xs={12}
                            >
                                <FileInputField
                                    {...register('files')}
                                    accept={[]}
                                    hideRejectedFiles={true}
                                    hideValidationsPanel={true}
                                    label='File Attachments'
                                    maxSize={5000000}
                                    name='files'
                                    onClear={handleClearFiles}
                                    onDropAccepted={handleAcceptedFiles}
                                    onDropRejected={handleRejectedFiles}
                                />
                                {alert}
                            </Grid>
                        </Grid>
                    </Box>
                </CardContent>
            </Card>
        </>
    );
}
